import { TAnalyticsData } from 'data/analytics';
import { getApiBaseUrl, sendApiRequest } from '.';

export const sendMetric = async <T>(
  metric: 'session' | 'customer' | 'rating',
  data: T,
  sendBeacon?: boolean,
  dedupeKey?: string
): Promise<void> => {
  try {
    // We could technically always use sendBeacon to send analytics requests
    // However for now we don't since using fetch enables better traceability and debugging in the browser tools

    // Under automation (Playwright sets navigator.webdriver = true), route through fetch
    // so the X-E2E-Test header injected via route interception (tests/utils/e2eMarker.ts)
    // attaches — sendBeacon is not interceptable and supports no custom headers, so it
    // would otherwise bypass the backend drop guard.
    if (sendBeacon && !navigator.webdriver) {
      const endpointUrl = `${getApiBaseUrl()}/analytics/${metric}`;
      navigator.sendBeacon(endpointUrl, JSON.stringify(data));
    } else {
      await sendApiRequest<TAnalyticsData>(`/analytics/${metric}`, {
        method: 'POST',
        body: data,
        dedupeKey,
      });
    }
  } catch (e) {
    console.error('Error while trying to send analytics metric.', e);
  }
};
